import { EventBus } from '@/app/event-bus'
import type { CanonicalCut } from '@/core/cuts'
import type { BnBNode } from '@/game/bnb-manager'
import type { CutHistoryItem } from '@/react/state/gameStore'

export type AppEvents = {
  // UI -> Engine command events
  'cut-select-requested': { cutIndex: number }
  'cut-confirm-requested': undefined
  'cut-cancel-requested': undefined
  'cut-mu-change-requested': { mu: number }
  'bnb-start-requested': undefined
  'bnb-branch-requested': { varIndex: number; mode: 'one' | 'both'; side?: 'le' | 'ge'; nodeId?: string }
  'bnb-select-requested': { nodeId: string }
  'bnb-backtrack-requested': { nodeId: string }

  // Gameplay/events still used by engine and UI adapters
  'cut-applied': {
    cut: CanonicalCut
    metrics: {
      newVolume: number
      volumeReductionPct: number
      currentObjectiveValue: number
      objectiveReductionPct: number
    }
    remainingCuts: number
  }
  'history-updated': { history: CutHistoryItem[] }
  'user-cut-added': { cut: CanonicalCut }
  'refresh-cuts': {}

  // Branch-and-Bound state events
  'bnb-started': { rootNodeId: string }
  'bnb-node-activated': { nodeId: string; node: BnBNode | null | undefined }
  'bnb-node-updated': { node: BnBNode }
  'bnb-incumbent-updated': { value: number; solution: number[]; nodeId?: string }
  'bnb-finished': {
    incumbent?: { value: number; solution: number[] }
    stats: { created: number; pruned: number; fathomed: number }
  }
  'bnb-reset-requested': {}
  'bnb-reset': {}
  'bnb-backtracked': {
    state: {
      nodes: Array<[string, BnBNode]>
      rootNodeId: string
      currentNodeId: string
      incumbentNodeId?: string | null
    }
  }
  'reset-game': {}
}

export const appBus = new EventBus<AppEvents>()
